import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const fetchEmailVendors = async (payload) => {
  try {
    const token = getToken();
    return await apiService.post(
      API_URL.EMAIL_VENDOR + "/fetch",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in fetchEmailVendors service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const createEmailVendor = async (payload) => {
  try {
    const token = getToken();
    return await apiService.post(
      API_URL.EMAIL_VENDOR + "/create",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in createEmailVendor service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const updateEmailVendor = async (payload) => {
  try {
    const token = getToken();
    return await apiService.put(
      API_URL.EMAIL_VENDOR + "/update",
      payload,
      token
    );
  } catch (err) {
    console.log("Error in updateEmailVendor service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};

export const testEmailVendor = async ({ id }) => {
  try {
    const token = getToken();
    return await apiService.post(
      `${API_URL.EMAIL_VENDOR}/${id}/test`,
      {},
      token
    );
  } catch (err) {
    console.log("Error in testEmailVendor service :", err);
    return { success: false, message: "Internal Server Error", data: null };
  }
};
